/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionFamilies = {
    MAIN: "M"
};

Merge2MissionFamilies.TYPE = {
    DROP: "drop",
    GOAL: "goal",
    TRANSFORM: "transform",
    COLLECT: "collect",
    INGREDIENT: "ingredient",
    CUSTOMER: "customer"
};

Merge2MissionFamilies.getJson = function () {
    return bundles.merge2mission_config.jsons.merge2mission_families_json.getJson();
};

Merge2MissionFamilies.getConfig = function () {
    return Merge2MissionFamilies.getJson().families;
};

Merge2MissionFamilies.getFirstStage = function (code) {
    const first = Merge2MissionFamilies.getConfig()[code].firstStage;

    return first === undefined ? 1 : first;
};

Merge2MissionFamilies.getStages = function (code) {
    const first = Merge2MissionFamilies.getFirstStage(code);

    return Merge2MissionFamilies.getConfig()[code].units.map((unit, index) => first + index);
};

Merge2MissionFamilies.getStageIndex = function (code, stage) {
    return stage - Merge2MissionFamilies.getFirstStage(code);
};

Merge2MissionFamilies.getId = function (code, stage) {
    return code + String(stage).padStart(2, "0");
};

Merge2MissionFamilies.parseId = function (id) {
    const match = id.match(/^([A-Za-z]+)(\d+)$/);

    return { code: match[1], stage: parseInt(match[2]) };
};

Merge2MissionFamilies.isSameItem = function (item, unit) {
    return item.code === unit.code && item.stage === unit.stage;
};

Merge2MissionFamilies.encodeUnit = function (code, stage) {
    return Merge2MissionFamilies.getConfig()[code].key + stage.toString(36);
};

Merge2MissionFamilies.decodeUnit = function (encoded) {
    const config = Merge2MissionFamilies.getConfig();

    return {
        code: Object.keys(config).find((code) => config[code].key === encoded[0]),
        stage: parseInt(encoded[1], 36)
    };
};

Merge2MissionFamilies.encodeCodes = function (byCode) {
    const byKey = {};

    Object.keys(byCode).forEach((code) => {
        byKey[Merge2MissionFamilies.getConfig()[code].key] = byCode[code];
    });

    return byKey;
};

Merge2MissionFamilies.decodeCodes = function (byKey) {
    const config = Merge2MissionFamilies.getConfig();
    const byCode = {};

    Object.keys(byKey).forEach((key) => {
        byCode[Object.keys(config).find((code) => config[code].key === key)] = byKey[key];
    });

    return byCode;
};

Merge2MissionFamilies.getGroups = function () {
    return Merge2MissionFamilies.getJson().groups;
};

Merge2MissionFamilies.getGroup = function (name) {
    return Merge2MissionFamilies.getGroups().find((group) => group.name === name);
};

Merge2MissionFamilies.getGroupItems = function (group) {
    const items = group.items.slice();

    group.codes.forEach((code) => {
        Merge2MissionFamilies.getStages(code).forEach((stage) => {
            items.push({ code, stage });
        });
    });

    return items;
};

Merge2MissionFamilies.isCollectable = function (code) {
    return Merge2MissionFamilies.getGroups().some((group) => Merge2MissionFamilies.getGroupItems(group).some((item) => item.code === code));
};

Merge2MissionFamilies.getStageConfig = function (code, stage) {
    return Merge2MissionFamilies.getConfig()[code].units[Merge2MissionFamilies.getStageIndex(code, stage)];
};

Merge2MissionFamilies.isPresented = function (code, stage) {
    if (Merge2MissionFamilies.getStageConfig(code, stage).type === Merge2MissionFamilies.TYPE.GOAL) {
        return false;
    }

    const fromStage = Merge2MissionFamilies.getConfig()[code].presentationFromStage;
    return fromStage !== undefined && stage >= fromStage;
};

Merge2MissionFamilies.isGroundable = function (code, stage) {
    return Merge2MissionFamilies.getStageConfig(code, stage).grounded !== false;
};

Merge2MissionFamilies.isValidStage = function (code, stage) {
    const index = Merge2MissionFamilies.getStageIndex(code, stage);

    return index >= 0 && index < Merge2MissionFamilies.getConfig()[code].units.length;
};

Merge2MissionFamilies.isLastStage = function (code, stage) {
    return Merge2MissionFamilies.getStageIndex(code, stage) >= Merge2MissionFamilies.getConfig()[code].units.length - 1;
};

Merge2MissionFamilies.getIcon = function (code, stage) {
    return Merge2MissionHelper.getBundle().frames[`merge2mission_${Merge2MissionFamilies.getId(code, stage)}_png`];
};

Merge2MissionFamilies.getClosedIcon = function (code, stage) {
    return Merge2MissionHelper.getBundle().frames[`merge2mission_${Merge2MissionFamilies.getId(code, stage)}_close_png`];
};

Merge2MissionFamilies.getSpine = function (code, stage) {
    return Merge2MissionHelper.getBundle().jsons[`merge2mission_${Merge2MissionFamilies.getId(code, stage)}_json`];
};

Merge2MissionFamilies.getName = function (code, stage) {
    const key = Merge2MissionHelper.getString(Merge2MissionHelper.getCurrentPeriod(), "Merge2MissionUnit", `.${Merge2MissionFamilies.getId(code, stage)}`);

    return Messages.has(key) ? Messages.get(key) : "";
};
